export default __webpack_public_path__ + "static/media/chubasquero-hombre.b3490b86.png";